import { HeadCell } from '../../../component/table/interfaces/TableInterface';

export const HEAD_CELL: Array<HeadCell> = [
  { id: 'store', label: 'Loja' },
  { id: 'type', label: 'Tipo' },
  // { id: 'origin', label: 'Origem' },
  { id: 'created_at', label: 'Data de Criação' },
  { id: 'sap_code', label: 'SKU' },
  { id: 'ean', label: 'EAN' },
  { id: 'description_product', label: 'Descrição Produto' },
  { id: 'state', label: 'Status Tarefa' },
];

export const HEAD_EXCEL = [
  { key: 'flag', label: 'Bandeira' }, // todos
  { key: 'region', label: 'Regional' }, // todos
  { key: 'store', label: 'Loja' }, // todos
  { key: 'type', label: 'Tipo' }, // todos
  { key: 'origin', label: 'Origem' }, // todos
  { key: 'created_at', label: 'Data de Criação' }, // todos
  { key: 'description_sector', label: 'Setor' }, // todos
  { key: 'description_section', label: 'Seção' }, // todos
  { key: 'sap_code', label: 'SKU' }, // todos
  { key: 'ean', label: 'EAN' }, // todos
  { key: 'description_product', label: 'Descrição Produto' }, // todos
  { key: 'state', label: 'Status Tarefa' }, // todos
  { key: 'stock', label: 'Estoque' }, // todos
  { key: 'unit_measurement', label: 'Unidade de Medida' }, // todos
  { key: 'minimum_qty_sale', label: 'Qtd. min. venda' }, // todos

  { key: 'quantity_sale', label: 'Qtd. vendida' }, // todos
  { key: 'qtd_n_entregue', label: 'Qtd. não entregue' }, // todos
  { key: 'qtd_entregue', label: 'Qtd. entregue' }, // todos
  { key: 'lost_sales', label: 'Qtd. visita shopper' }, // todos
  { key: 'quantity_sale_nominal', label: 'Qtd. vendida (origem)' }, // todos
  { key: 'qtd_n_entregue_nominal', label: 'Qtd. não entregue (origem)' }, // todos

  { key: 'user_closed', label: 'Usuário Encerramento' }, // todos
  { key: 'date_closed', label: 'Data Encerramento' }, // todos
  { key: 'is_scanned', label: 'Produto foi escaneado no encerramento?' }, // todos
  { key: 'product_was_gondola', label: 'Produto está na gôndola?' }, // todos
  { key: 'reason', label: 'Razão' }, // todos
  { key: 'justification', label: 'Justificativa' }, // todos

  { key: 'date_brigade', label: 'Data da Brigada' }, // todos
  { key: 'date_validity', label: 'Data Validade' }, // todos
  { key: 'validity_quantity', label: 'Qtd. brigada' }, // todos
  { key: 'task_origin', label: 'Origem de Criação' }, // todos
  { key: 'user', label: 'Criado por' }, // todos
  { key: 'zzcod_tarefa', label: 'Id Tarefa Sap' }, // todos
  { key: '_id', label: 'Id Tarefa Arcus' }, // todos
  { key: 'task_replaced_id', label: 'Id Tarefa Arcus Substituida' }, // todos
  { key: 'qtd_replaced', label: 'Qtd. Substituições de Tarefa' }, // todos
  { key: 'replaced_at', label: 'Data de Substituição' }, // todos
];
